import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import isToday from 'date-fns/isToday';
import CalendarDay from './CalendarDay';
import { getCurrentMonth } from '../../../helpers/dates';
import * as Styled from './styled';

interface ICalendarWeek {
  month: any;
  year: any;
  daysTimes: any;
  isDateSelected: any;
  onDateSelected: any;
}

const CalendarWeek = ({
  month,
  year,
  daysTimes,
  isDateSelected,
  onDateSelected,
}: ICalendarWeek) => {
  const weeks = getCurrentMonth(month, year);

  return (
    <Fragment>
      {weeks.map((week, weekId) => (
        <Styled.Row key={weekId}>
          {week.map((date) => (
            <Styled.Cell // eslint-disable-next-line react/no-array-index-key
              key={`${weekId}_${date.day}`}
            >
              <CalendarDay
                date={date}
                isToday={isToday(date)}
                isSelected={isDateSelected(date)}
                isDisabled={date.isPrev || date.isNext || !daysTimes.get(date.dateStr)}
                onSelect={onDateSelected}
                daysTimes={daysTimes}
              />
            </Styled.Cell>
          ))}
        </Styled.Row>
      ))}
    </Fragment>
  );
};

// @ts-ignore
export default withTheme(CalendarWeek) as (props: ICalendarWeek) => JSX.Element;
